import React, { FunctionComponent, useContext, useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

import { setLoggingContext, setRumContext } from '../../utils/logging';
import Api from '../Api/Api';
import App from '../App/App';
import { AuthContextTrace } from '../Authenticate/AuthenticateTrace';
import Onboarding from '../Onboarding/Onboarding';
import URLState from '../URLState/URLState';

const Root: FunctionComponent = () => {
  const { action, location } = useHistory();
  const {
    data: { appId },
  } = useContext(AuthContextTrace);

  useEffect(() => {
    setLoggingContext({ appId });
    setRumContext({ appId });
  }, [appId]);

  useEffect(() => {
    if (action === 'PUSH') {
      window.scrollTo({ top: 0 });
    }
  }, [location.pathname, action]);

  return (
    <URLState>
      <Api>
        <Switch>
          <Route component={Onboarding} path="/:appId/o" />
          <Route component={App} path="/:appId" />
        </Switch>
      </Api>
    </URLState>
  );
};

export default Root;
